import {
  faCheck,
  faPenToSquare,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCostLinesStore } from "entities/CostLines/store/useCostLinesStore";
import { useRequestStore } from "entities/Request";
import { userStore } from "entities/User/store/userStore";
import ReasonOfCostLineRejection from "modules/Expenses/ui/ReasonOfCostLineRejection/ReasonOfCostLineRejection";
import { memo, useState } from "react";
import { Col, Row, ToggleButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ROLES } from "shared/config";
import { Button } from "ui";

// TODO decomposition according to fsd

function CostLineAcceptanceActionsBar({
  idx,
  userRole,
  costLine,
  isEditable,
  isAccepted,
  isRejected,
  rejection,
  costLinesRefs,
}) {
  const { t } = useTranslation(["CostLine", "CostGroup"]);
  const user = userStore((state) => state.user);
  const onHold = useRequestStore((state) => state.onHold);
  const request = useRequestStore((state) => state.request);

  const [showReasonOfCostLineRejection, setShowReasonOfCostLineRejection] =
    useState(false);

  const costLinesState = useCostLinesStore((state) => state.costLinesState);

  const isLocked =
    request.locks?.data?.holder_id !== undefined &&
    request.locks?.data?.holder_id !== user.id;

  const handleCostLineAccept = (idx) => {
    costLinesRefs[idx].current?.accept();
  };

  return (
    <>
      <Row className="px-3 pt-4">
        <Col md>
          {showReasonOfCostLineRejection ? (
            <ReasonOfCostLineRejection
              setShowReasonOfCostLineRejection={
                setShowReasonOfCostLineRejection
              }
              rejection={
                rejection?.acceptor_role === userRole ? rejection : null
              }
              costLineId={costLine.id}
              userRole={userRole}
            />
          ) : isRejected ? (
            <div className="text-danger">
              <p className="m-0">
                <strong>
                  {rejection?.acceptor_role === ROLES.COST_GROUP
                    ? t("reasons_of_cost_group_rejection", {
                        ns: "CostGroup",
                      })
                    : t("labels.rejection_comment")}
                </strong>
              </p>
              {rejection?.comment !== "null" && rejection?.comment !== "" && (
                <p className="m-0">{rejection?.comment}</p>
              )}
              {rejection?.rejection_reasons?.data?.length > 0 && (
                <div>
                  <strong>{t("labels.rejection_reasons")}</strong>
                  <ul className="m-0">
                    {rejection?.rejection_reasons?.data?.map((reason, idx) => (
                      <li key={idx}>{reason.rejection_name}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ) : (
            costLine.acceptations?.data?.acceptor_role === ROLES.COST_GROUP &&
            costLine.acceptations?.data?.decision === "Accepted" && (
              <p className="m-0 text-success">
                <strong>
                  {t("accepted_by_cost_group", { ns: "CostGroup" })}
                </strong>{" "}
              </p>
            )
          )}
        </Col>
        {isEditable && (
          <Col md>
            <div className="d-flex h-100 justify-content-end align-items-end gap-2">
              {isRejected && userRole === rejection?.acceptor_role && (
                <ToggleButton
                  id={`rejection-toggle${costLine.id}`}
                  type="checkbox"
                  variant="outline-primary"
                  checked={showReasonOfCostLineRejection}
                  value="1"
                  onChange={() =>
                    setShowReasonOfCostLineRejection(
                      !showReasonOfCostLineRejection
                    )
                  }
                >
                  <FontAwesomeIcon icon={faPenToSquare} />
                </ToggleButton>
              )}
              <Button
                variant="warning"
                className="mt-3"
                style={{ whiteSpace: "nowrap" }}
                disabled={
                  showReasonOfCostLineRejection ||
                  onHold === "on" ||
                  (isLocked &&
                    [ROLES.ACCOUNTS_PAYABLE, ROLES.COST_GROUP].some(
                      (role) => role === userRole
                    )) ||
                  isRejected ||
                  // disable Accept button for AP role if cost line was previously decided by Cost Group
                  (userRole === ROLES.ACCOUNTS_PAYABLE &&
                    (rejection?.acceptor_role === ROLES.COST_GROUP ||
                      costLine.acceptations?.data?.acceptor_role ===
                        ROLES.COST_GROUP))
                }
                onClick={() =>
                  setShowReasonOfCostLineRejection(
                    !showReasonOfCostLineRejection
                  )
                }
              >
                {isRejected ? (
                  <>
                    {t("buttons.rejected")}
                    <FontAwesomeIcon icon={faXmark} className="ms-2" />
                  </>
                ) : (
                  t("buttons.reject")
                )}
              </Button>
              <Button
                type="submit"
                className="btn-success mt-3"
                variant="success"
                onClick={() => handleCostLineAccept(idx)}
                isLoading={costLinesState[costLine.id]?.isAccepting}
                style={{ whiteSpace: "nowrap" }}
                disabled={
                  costLinesState[costLine.id]?.isAccepting ||
                  costLinesState[costLine.id]?.isRejecting ||
                  (isLocked &&
                    [ROLES.ACCOUNTS_PAYABLE, ROLES.COST_GROUP].includes(
                      userRole
                    )) ||
                  isAccepted ||
                  onHold === "on" ||
                  // disable Accept button for AP role if cost line was previously decided by Cost Group
                  (userRole === ROLES.ACCOUNTS_PAYABLE &&
                    (rejection?.acceptor_role === ROLES.COST_GROUP ||
                      costLine.acceptations?.data?.acceptor_role ===
                        ROLES.COST_GROUP))
                }
              >
                {isAccepted ? (
                  <>
                    {t("buttons.accepted")}
                    <FontAwesomeIcon icon={faCheck} className="ms-2" />
                  </>
                ) : (
                  t("buttons.accept")
                )}
              </Button>
            </div>
          </Col>
        )}
      </Row>
    </>
  );
}

export default memo(CostLineAcceptanceActionsBar);
